import { ITabsItem, Tabs } from '@reapitform/common-ui'
import { PageContent, PageLayout } from '@reapitform/dashboard-ui'
import { AgreementOpenTab } from './view/agreement-open-tab'
import { AgreementCloseTab } from './view/agreement-close-tab'

const tabItems: ITabsItem[] = [
  {
    name: 'open',
    title: 'Open',
    component: <AgreementOpenTab />,
  },
  {
    name: 'closed',
    title: 'Closed',
    component: <AgreementCloseTab />,
  },
]

export const AgreementPage = () => {
  return (
    <PageLayout pageTitle="Agreements">
      <PageContent>
        <Tabs tabItems={tabItems} />
      </PageContent>
    </PageLayout>
  )
}
